export default __webpack_public_path__ + "static/media/text-align-left.809d40a6.svg";